/**
 * String utility functions
 */

/**
 * Generate initials from a name/title string
 * @param {string} name - The input string to generate initials from
 * @returns {string} - Two letter initials in uppercase
 *
 * Examples:
 * - "Tasks for Designer" → "TD" (first letter of first + first letter of last word)
 * - "GrowMindGrow" → "GR" (first two letters of single word)
 * - "GiraffeSoftware Processes" → "GP" (first letter of first + first letter of last word)
 * - "IOS team" → "IT" (first letter of first + first letter of last word)
 */
export function getInitials (name) {
  if (!name || typeof name !== 'string') return ''

  const words = name.trim().split(/\s+/)

  if (words.length === 1) {
    // Single word: take first two letters
    const word = words[0]
    return word.length >= 2 ? word.substring(0, 2).toUpperCase() : word.toUpperCase()
  } else {
    // Multiple words: first letter of first word + first letter of last word
    const firstLetter = words[0].charAt(0)
    const lastLetter = words[words.length - 1].charAt(0)
    return (firstLetter + lastLetter).toUpperCase()
  }
}
